// SPDX-License-Identifier: AGPL-3.0-or-later

// KONVO: compact rows have no avatar or bubble to mark a new speaker, so each
// person's name gets one of eight hues. The hues live in globals.css as
// --message-author-N, so light and dark themes tune them without touching code.
export const MESSAGE_AUTHOR_HUES = 8;

/**
 * Small chats (DMs and group DMs) pass their participants so everyone gets a
 * different hue; bigger chats fall back to a stable hash of the user id.
 */
export function messageAuthorHue(userId: string, participantIds?: ReadonlyArray<string>): number {
	if (participantIds && participantIds.length <= MESSAGE_AUTHOR_HUES) {
		const index = [...new Set(participantIds)].sort().indexOf(userId);
		if (index >= 0) return index;
	}
	let hash = 0;
	for (const char of userId) hash = (hash * 31 + char.charCodeAt(0)) >>> 0;
	return hash % MESSAGE_AUTHOR_HUES;
}

export function messageAuthorColour(userId: string, participantIds?: ReadonlyArray<string>): string {
	return `var(--message-author-${messageAuthorHue(userId, participantIds)})`;
}
